import React, { Fragment } from 'react';
import { navigate } from 'gatsby';
import Downshift from 'downshift';
import Input from 'reusecore/src/elements/Input';
// import Box from 'reusecore/src/elements/Box';
// import Text from 'reusecore/src/elements/Text';
// import Heading from 'reusecore/src/elements/Heading';
// import Button from 'reusecore/src/elements/Button';
import { Icon } from 'react-icons-kit';
import { magnifying_glass } from 'react-icons-kit/ikons/magnifying_glass';
import SearchbarLabel, { DropDown, DropDownItem } from './searchbar.style';

// const items = [
//   { value: 'apple' },
//   { value: 'pear' },
//   { value: 'orange' },
//   { value: 'grape' },
//   { value: 'banana' }
// ];

const Searchbar = props => {
  const { searchable, width = '40%', current } = props;
  const elements = searchable.map(item => item.node && item.node.frontmatter);
  // <SearchbarLabel>
  //   <Input
  //     icon={<Icon icon={magnifying_glass} />}
  //     placeholder="Buscar..."
  //     value={currentSearch}
  //     onChange={e => setcurrentSearch(e.target.value)}
  //   />
  // </SearchbarLabel>
  return (
    <Downshift
      onChange={item => item && navigate(`/producto/${item.slug}`)}
      itemToString={item => (item ? item.title : '')}
      resultCount={5}
      selectedItem={current && current.frontmatter}
    >
      {({
        getInputProps,
        getItemProps,
        // getMenuProps,
        isOpen,
        inputValue,
        highlightedIndex
        // selectedItem
      }) => {
        // const itemsToShow = elements.filter(item => !inputValue || item.title.includes(inputValue));
        const itemsToShow = elements.filter(item =>
          item.title.toLowerCase().includes(inputValue.toLowerCase())
        );
        return (
          <div style={{ width, textAlign: 'end' }}>
            <SearchbarLabel isOpen={isOpen}>
              <Fragment>
                <Input
                  icon={<Icon icon={magnifying_glass} />}
                  placeholder="Buscar..."
                  {...getInputProps()}
                />
                {isOpen && (
                  <DropDown>
                    {itemsToShow.map((item, index) => (
                      <DropDownItem
                        {...getItemProps({ index, item })}
                        key={item.title}
                        highlighted={index === highlightedIndex}
                        className="search_item"
                      >
                        <img width="50" src={item.thumbnail} alt={item.title} />
                        {item.title}
                      </DropDownItem>
                    ))}
                    {!itemsToShow.length && (
                      <DropDownItem fallback>{`Sin productos con "${inputValue}"`}</DropDownItem>
                    )}
                  </DropDown>
                )}
              </Fragment>
            </SearchbarLabel>
          </div>
        );
      }}
    </Downshift>
  );
};

export default Searchbar;
